export default {
  meta: {
    title: '评估报告',
    url: '/insight/map', // 埋点字段，上报归属的模块
    urlName: '商圈洞察' // 埋点字段，上报归属的模块
  }
};
